import { css, StyleDeclarationValue } from 'aphrodite';
import * as React from 'react';
import { DeprecatedCloseButton } from '../../DeprecatedCloseButton';
import { ColorCodedCard } from '../ColorCodedCard';
import { styleSheet } from './styles';

export interface IFeedCardCallbackProps {
	onRequestRemove?(): void;
	onShowDeleteConfirmation?(performDelete: () => void): void;
	onShowWasReminderHelpfulModal?(): void;
	onSuppressClicked?(): void;
}

interface IProps {
	className?: string;
	footer?: React.ReactNode;
	hideHeader?: boolean;
	indicatorColor?: string;
	onClick?(e: React.MouseEvent<HTMLElement>): void;
	onSuppressClicked?(): void;
	showSuppressOption?: boolean;
	styles?: StyleDeclarationValue[];
	moreMenu?: React.ReactNode;
}

export class FeedCard extends React.PureComponent<React.PropsWithChildren<IProps>> {
	public render() {
		const {
			className,
			children,
			indicatorColor,
			footer,
			onClick,
			hideHeader,
			onSuppressClicked,
			showSuppressOption,
			moreMenu,
			styles,
			...restProps
		} = this.props;
		return (
			<ColorCodedCard
				className={`feed-card ${className || ''}`}
				footer={footer}
				header={this.renderHeader()}
				hideHeader={!!hideHeader}
				indicatorColor={indicatorColor}
				onClick={onClick}
				styles={[styleSheet.container, ...(styles || [])]}
				{...restProps}
			>
				{children}
			</ColorCodedCard>
		);
	}

	private renderHeader() {
		const { showSuppressOption, onSuppressClicked, moreMenu } = this.props;

		const showMoreMenu = !!moreMenu;

		if (!showSuppressOption && !showMoreMenu) {
			return null;
		}

		return (
			<div className={css(styleSheet.header)}>
				{showMoreMenu ? <>{moreMenu}</> : null}
				{!showMoreMenu && !!showSuppressOption && onSuppressClicked && (
					<DeprecatedCloseButton onClick={onSuppressClicked} />
				)}
			</div>
		);
	}
}
